import Separator from 'components/common/separator';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import CruiseSaleCruiseCard from './cruise-card';
import CruiseGuestCard from './guest-card';

export default function CruiseItems() {
  const { control } = useFormContext();
  const cruiseSales = useWatch({ control, name: 'approvalable.cruiseSales' });
  return (
    <>
      <CruiseSaleCruiseCard />
      <Separator gap={22} />

      {cruiseSales.map((cs, idx) => (
        <React.Fragment key={cs.id}>
          <CruiseGuestCard parentIndex={idx} />
          <Separator gap={22} />
        </React.Fragment>
      ))}
    </>
  );
}
